import Pill, {PillProps} from './Pill'

export type { PillProps };
export default Pill